import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { makeQuickFetchRequest } from '../../utils/makeQuickFetchRequest';

export const OBJECT_TYPE_IDS_IN_VIEW_NAMESPACES_QUERY_NAME =
  'objectTypeIdsInViewNamespaces' as const;

export type ObjectTypeIdsInViewNamespacesQueryType = {
  namespaces: string[];
};

const queryArguments: (keyof ObjectTypeIdsInViewNamespacesQueryType)[] = [
  'namespaces',
];

export type ObjectTypeIdsInViewNamespacesResponseType = string[];

const fetcher = ({ namespaces }: { namespaces: string[] }) =>
  makeQuickFetchRequest<ObjectTypeIdsInViewNamespacesResponseType>({
    requestName: OBJECT_TYPE_IDS_IN_VIEW_NAMESPACES_QUERY_NAME,
    makeRequestFn: () => {
      const baseUrl = `sales/v4/views/objectTypeIds`;

      const searchParams = new URLSearchParams(
        namespaces.map((namespace) => ['namespace', namespace])
      );

      const url = `${baseUrl}?${searchParams.toString()}`;

      return http.get(url);
    },
  });

export const ObjectTypeIdsInViewNamespacesQuery = registerQuery<
  typeof OBJECT_TYPE_IDS_IN_VIEW_NAMESPACES_QUERY_NAME,
  ObjectTypeIdsInViewNamespacesQueryType,
  ObjectTypeIdsInViewNamespacesResponseType
>({
  fieldName: OBJECT_TYPE_IDS_IN_VIEW_NAMESPACES_QUERY_NAME,
  args: queryArguments,
  fetcher: (args) => fetcher(args).requestPromise,
});

export const useFetchObjectTypeIdsInViewNamespaces = ({
  namespaces,
  skip,
}: {
  namespaces: string[];
  skip?: boolean;
}) =>
  useQuery(ObjectTypeIdsInViewNamespacesQuery, {
    variables: {
      namespaces,
    },
    skip,
  });
